import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  show() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.contentTarget.classList.add("tooltip-visible")
    }, 200)
  }

  hide() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.contentTarget.classList.remove("tooltip-visible")
    }, 100)
  }

  hideOutside(event) {
    if (!this.element.contains(event.target)) {
      this.contentTarget.classList.remove("tooltip-visible")
    }
  }
}
